import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AxiosError } from "axios";
import "./contact.css";
import { useNavigate } from "react-router-dom";
import { server } from "../../common";
import { toast } from "react-toastify";
import configContext from "../../context/configContext/configContext";

const initialValues = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

const Contact = () => {
  document.title = "Contact";
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  const { values, handleBlur, handleSubmit, handleChange, resetForm, errors } =
    useFormik({
      initialValues: initialValues,
      validationSchema: Yup.object({
        name: Yup.string()
          .min(2, "Enter Full Name")
          .required("Please Enter Your Name"),
        email: Yup.string()
          .email("Enter a valid email")
          .required("Please Enter Your Email"),

        subject: Yup.string()
          .min(2, "Enter details")
          .required("Please Enter Your Message"),

        message: Yup.string()
          .min(2, "Enter details")
          .required("Please Enter Your Message"),
      }),
      onSubmit: (values) => {
        setProcessing(true);
        setProgress(10);
        server
          .post("/contact/addcontact", values, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then(function (response) {
            console.log("api response", response.data);
            if (response.status === 200 || response.status === 201) {
              if (response.data) {
                // dispatch(loginUser({ authToken: response.data.token }));
                toast.success("Message sent  successfully");
                navigate("/");
                resetForm();
                setProgress(100);
              }
              setProcessing(false);
            }
          })
          .catch(function (error) {
            if (error instanceof AxiosError && error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else {
              toast.error("Failed to connect to server");
              console.log(error.message);
            }
            setProcessing(false);
            setProgress(100);
          });
      },
    });

  return (
    <>
      <div id="contact" className="container-xl mt-2 ">
        <div className="container-xl shadow  p-5" style={{ marginTop: "1rem" }}>
          <div className="section-title text-center">
            <h1 className="text-uppercase">Get in Touch</h1>
            <p>
              Let's Connect! Have questions Reach out to us – we'd love to hear
              from you!
            </p>
          </div>
          <div className="row">
            <div className="col-lg-7">
              <div className="contact">
                <form className="form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        value={values.name}
                        onChange={handleChange}
                        required="required"
                      />
                      {errors.name ? (
                        <p className="text-danger mb-0">{errors.name}</p>
                      ) : null}
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={values.email}
                        onChange={handleChange}
                        required="required"
                      />
                      {errors.email ? (
                        <p className="text-danger mb-0">{errors.email}</p>
                      ) : null}
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        placeholder="Subject"
                        value={values.subject}
                        onChange={handleChange}
                        required="required"
                      />
                      {errors.subject ? (
                        <p className="text-danger mb-0">{errors.subject}</p>
                      ) : null}
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <textarea
                        rows={6}
                        name="message"
                        className="form-control"
                        placeholder="Your Message"
                        value={values.message}
                        onChange={handleChange}
                        required="required"
                        defaultValue={""}
                      />
                      {errors.message ? (
                        <p className="text-danger mb-0">{errors.message}</p>
                      ) : null}
                    </div>
                    <button
                      type="submit"
                      value="Send message"
                      name="submit"
                      id="submitButton"
                      className="btn btn-sm btn-dark text-white fw-bold rounded-4 p-3"
                      title="Submit Your Message!"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
            {/*- END COL */}
            <div className="col-lg-5">
              <div className="single_address">
                <i className="fa fa-map-marker" />
                <h4>Our Address</h4>
                <p>
                  व्रज लाइफ स्पेस, शॉप नं. ११६, आर.टी.ओ. ऑफीस समोर, पेठरोड,
                  नाशिक ३
                </p>
              </div>
              <div className="single_address">
                <i className="fa fa-envelope" />
                <h4>Send your message</h4>
                <p>marathwadasfoundation@gmail.com</p>
              </div>
              <div className="single_address">
                <i className="fa fa-phone" />
                <h4>Call us on</h4>
                <p> ९५४५८३४२२२ / ९६३७९५४८७७ </p>
              </div>
              <div className="single_address">
                <i className="fa fa-clock" />
                <h4>Work Time</h4>
                <p>
                  Mon - Fri: 08.00 - 16.00. <br />
                  Sat: 10.00 - 14.00
                </p>
              </div>
            </div>
            {/*- END COL */}
          </div>
          {/*- END ROW */}
        </div>
        {/*- END CONTAINER */}
      </div>
    </>
  );
};

export default Contact;
